import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';

export { FormControlLabel, FormControlLabelProps };
